import { Radio, Space, Form, Row, Col, notification, Modal } from 'antd';
import React, { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { PrimaryButtonX } from '../Components/Button3D';
import FooterPublic3D from '../Components/FooterPublic3D';
import HeaderComponent from '../Components/HeaderComponents';
import { Input3D } from '../Components/Input3D';
import { ExpertText, SmallText } from '../Components/Text3D';
import { useStoreState, useStoreActions } from '../myStore';

// const { Option } = Select;

const MainWrapper = styled(Row)`
`
const Content = styled(Col)`
    background-color: white;
    width: 100%;
    font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
`
const TopSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2rem 0 .6rem .5rem;
    margin: 0 2rem;
    border-bottom: 1px solid #D8D8D8;
`;
const ContentWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2rem;
`;
const ContentSection = styled.div`
`
const ContentBox = styled.div`
    border: 1px solid #D8D8D8;
`
const ContentDiv = styled.div`
    padding: 2rem;
`
const RadioDiv = styled.div`
    padding: .8rem 0 0 1.5rem;
`
const Span = styled.span`
    font-size: 16px;
`

const UploadNewPublishP: FC = () => {
    const history = useHistory()
    const [value, setValue] = useState();
    const [price, setPrice] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const currentItem = useStoreState((state: any) => state.cart.currentItem);
    const setCurrentItem = useStoreActions((actions: any) => actions.cart.setCurrentItem);
    const onChange = (e: any) => {
        setValue(e.target.value);
    };

    const handleTypeClick = (e: any) => {

        if (!value) {
            notification.error({
                message: "Error",
                description: "Please choose one of the plan"
            })
        } else {
            if (value === "PAID") {
                if (!price) {
                    notification.error({
                        message: "Error",
                        description: "choose the best price for your design"
                    })
                } else {
                    let items = currentItem.map(design => {
                        return {
                          ...design,
                          uploadType: value,
                          designPrice: price,
                        };
                    });
                    setCurrentItem(items)
                    history.push("/design/other-info");
                }
            }
            else if(value === "PRIVATE") {
                let items = currentItem.map((design) => {
                    const orgDesignName = design?.files[0]?.name || "3dprintit";
                    const finalDesignName = orgDesignName.replaceAll(
                      ".stl",
                      ""
                    );
                  return {
                    ...design,
                    uploadType: value,
                    designName: finalDesignName,
                  };
                });
                setCurrentItem(items);
                history.push("/design/quantity");
            
            } else {
                let items = currentItem.map((design) => {
                  return {
                    ...design,
                    uploadType: value,
                  };
                });
                setCurrentItem(items);
                history.push("/design/other-info")
            }
        }

    };


    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            <MainWrapper>
                <HeaderComponent />
                <Content>
                    <TopSection>
                        <ExpertText dark><a href="/signin
                        ">Upload New Design</a></ExpertText>
                    </TopSection>
                    <ContentWrapper>
                        <ContentSection>
                            <ContentBox>
                                <ContentDiv>
                                    <SmallText size line><a href="q">Upload this to marketplace for</a></SmallText>
                                    <Form.Item >
                                        <RadioDiv>
                                            <Radio.Group onChange={onChange} value={value}>
                                                <Space direction="vertical">
                                                    <Radio value='FREE'><Span>Free Use</Span></Radio>
                                                    <Radio
                                                        value='PAID'
                                                        onClick={showModal}
                                                    // disabled={ !user || user.paymentSetupComplete === false}
                                                    >
                                                        <Span>Paid on download</Span>
                                                    </Radio>
                                                    <Radio value='PRIVATE'><Span>Private</Span></Radio>
                                                </Space>
                                            </Radio.Group>
                                        </RadioDiv>
                                    </Form.Item>
                                </ContentDiv>
                            </ContentBox>
                            <Modal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                                <p>Enter best price for your design <strong>{"(In USD)"}</strong></p>
                                <Input3D type='number' onChange={(e) => setPrice(Number(e.target.value))} />
                            </Modal>
                            <div style={{ display: 'flex', flexFlow: 'row', justifyContent: 'flex-start' }}>
                                <PrimaryButtonX type='primary' style={{ margin: '2rem 0' }} onClick={handleTypeClick} >next</PrimaryButtonX>
                            </div>
                        </ContentSection>
                    </ContentWrapper>
                </Content>
                <FooterPublic3D />
            </MainWrapper>
        </>
    )
}
export default UploadNewPublishP;